(() => {
  if (window.tribeNavigationBound) return;
  window.tribeNavigationBound = true;

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    const link = event.target instanceof Element
      ? event.target.closest('.tribe-theme header-drawer a[href]')
      : null;
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const destination = new URL(link.href, window.location.href);
    if (
      destination.origin !== window.location.origin ||
      destination.pathname !== window.location.pathname ||
      !destination.hash
    ) return;

    const drawer = link.closest('header-drawer');
    const details = drawer?.mainDetailsToggle;
    if (!details?.hasAttribute('open') || typeof drawer.closeMenuDrawer !== 'function') return;

    const summary = details.querySelector('summary');
    if (!summary) return;

    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  });
})();
